import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  wrapper: {
    margin: '78px 0 30px'
  },
  passPrices: {
    margin: '30px 0',
    
  },
  passFixedPrices: {
    margin: '78px 0 30px'
  },
  title: {
    marginBottom: '10px',
  }
});
